import Establishment from "./Establishment";

export default Establishment;
